import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { getEsppQuoterCachedValue, initEsppQuoterCacheSessionLifecycle, QUOTE_TYPES_CACHE_STORAGE_KEY, QUOTER_CACHE_STORAGE_KEYS, setEsppQuoterCachedValue } from '../cache-storage/espp-quoter-cache-storage';

@Injectable()
export class QuoteTypeService {

  private quoteTypesCache = new Map<string, { [key: string]: string }[]>();

  constructor(private http: HttpClient) {
    initEsppQuoterCacheSessionLifecycle(QUOTER_CACHE_STORAGE_KEYS);
  }

  public getQuoteTypes(dealershipId?: string | number): Observable<{[key: string]: string}[]>{
    const cacheKey = `${dealershipId ?? ''}`;
    const cachedQuoteTypes = this.quoteTypesCache.get(cacheKey);
    if (cachedQuoteTypes?.length) {
      setEsppQuoterCachedValue(QUOTE_TYPES_CACHE_STORAGE_KEY, cacheKey, cachedQuoteTypes);
      return of(cachedQuoteTypes);
    }

    const storedQuoteTypes = getEsppQuoterCachedValue<{ [key: string]: string }[]>(QUOTE_TYPES_CACHE_STORAGE_KEY, cacheKey);
    if (storedQuoteTypes?.length) {
      this.quoteTypesCache.set(cacheKey, storedQuoteTypes);
      return of(storedQuoteTypes);
    }

    return this.http.get<{[key: string]: string}[]>('api/v1/espp/quote_types')
      .pipe(
        tap((quoteTypes) => {
          if (quoteTypes.length > 0) {
            this.quoteTypesCache.set(cacheKey, quoteTypes);
            setEsppQuoterCachedValue(QUOTE_TYPES_CACHE_STORAGE_KEY, cacheKey, quoteTypes);
          }
        }),
        catchError(error => of([]))
      );
  }
}
